float luma(vec3 rgb) {
    return dot(rgb, vec3(0.2126, 0.7152, 0.0722));
}

float map(float value, float min1, float max1, float min2, float max2) {
	return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
}

vec3 levelRange(vec3 color, float minInput, float maxInput) {
	return min(max(color - vec3(minInput), vec3(0.0)) / (vec3(maxInput) - vec3(minInput)), vec3(1.0));
}


float maxComponent(vec3 color) {
	return max(max(color.r, color.g), color.b);
}

// https://catlikecoding.com/unity/tutorials/advanced-rendering/bloom/
vec3 contribColorAboveThresh(vec3 color, float threshold) {
	float brightness = maxComponent(color);
	float contribution = max(0., brightness - threshold);
	contribution /= max(brightness, 0.00001);
	return color * contribution;
}

vec3 contribColorAboveThresh(vec3 color, float threshold, float softCutoff) {
	float brightness = maxComponent(color);
	float knee = threshold * softCutoff;
	float soft = brightness - threshold + knee;
	soft = clamp(soft, 0., 2. * knee);
	soft = soft * soft / (4. * knee + 0.00001);
	float contribution = max(soft, brightness - threshold);
	contribution /= max(brightness, 0.00001);
	return color * contribution;
}

bool isEvenTexel(float texelCoord) {
	float floored = floor(texelCoord);
	if (mod(floored, 2.) < 1.) {
		return true;
	} else {
		return false;
	}
}

bool hasEvenTexel(vec2 texelCoords) {
	if (isEvenTexel(texelCoords.x) || isEvenTexel(texelCoords.y)) {
		return true;
	} else {
		return false;
	}
}

uniform float threshold;
uniform float opacity;

void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
    vec3 colOut = inputColor.rgb;
	float highlight = 0.;

	float maxColor = maxComponent(inputColor.rgb);

	if (maxColor > threshold) {
		colOut = contribColorAboveThresh(inputColor.rgb, threshold, 0.85);

        // An attempt to pass through fewer bright areas:
        // float rand(vec2 co) {
        //     return fract(sin(dot(co, vec2(12.9898, 78.233))) * 43758.5453);
        // }
		// float randomFloat = rand(uv);
		// if (randomFloat >= 0.45) {} 
	
		float addedChannels = (colOut.r + colOut.g + colOut.b) / 3.;
		highlight = map(addedChannels, 0., maxColor, 0.9, 1.0);
		
		colOut.rgb = mix(vec3(0.), colOut.rgb, opacity);
	}

	outputColor = vec4(colOut, highlight);
}
